import React from "react";
import { Plug } from "lucide-react";

export const PlayerMcps = ({ mcps }) => (
  <section data-testid="player-step-mcps">
    <p className="text-[11px] uppercase tracking-[0.18em] text-slate-500">
      {mcps.agent_name} · {mcps.items.length} conexiones detectadas en la entrevista
    </p>
    <div className="mt-6 overflow-x-auto border border-slate-200 bg-white">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-slate-200 text-left text-[10px] uppercase tracking-[0.18em] text-slate-500">
            <th className="px-4 py-3">Sistema (MCP)</th>
            <th className="px-4 py-3">Actividad</th>
            <th className="px-4 py-3">Cargo que lo opera</th>
            <th className="px-4 py-3">Mencionado como</th>
          </tr>
        </thead>
        <tbody>
          {mcps.items.map((m) => (
            <tr key={`${m.label}-${m.activity}`} className="border-b border-slate-100" data-testid="player-mcp-row">
              <td className="px-4 py-3">
                <p className="flex items-center gap-2 font-medium text-slate-900">
                  <Plug className="h-3.5 w-3.5 text-accent-blue" /> {m.label}
                </p>
                <p className="text-[10px] uppercase tracking-[0.14em] text-slate-400">{m.category}</p>
              </td>
              <td className="px-4 py-3 text-slate-700">{m.activity}</td>
              <td className="px-4 py-3 text-slate-700">{(m.roles || []).join(", ") || "—"}</td>
              <td className="px-4 py-3 text-xs text-slate-500">{m.evidence}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </section>
);
